import ajax from '../ajax'
//获取图片列表
export function Aiapi(params) {
    return ajax({
        method: 'GET',
        url: '/v2/user/ai',
        params
    })
}
export function editListApi(data) {
    return ajax({
        method:'post',
        url: 'v2/user/edit',
        data
    })
}


export function alterApi(data) {
    return ajax({
        method:'post',
        url: 'v2/user/alter',
        data
    })
}


export function TypeNameApi(data) {
    return ajax({
        method:'post',
        url: '/v2/user/typename',
        data
    })
}




// WEBPACK FOOTER //
// ./src/apis/ai/index.js